import React from 'react';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import ContainerHead from 'src/components/ui/ContainerOverlay/ContainerHead/ContainerHead';
import OverlayNavArrows from 'src/components/layouts/OverlayNavArrows/OverlayNavArrows';
import { useOverlay } from '../../../providers/OverlayProvider';

type Props = {
  title?: string;
  onCloseOverlay?: () => void;
};
const OverlayHead = ({ title, onCloseOverlay }: Props) => {
  const { onClose, actions } = useOverlay();

  return (
    <ContainerHead>
      <Button
        icon="keyboard-tab-right"
        onClick={() => (onCloseOverlay ? onCloseOverlay() : onClose())}
        tone={ButtonToneProps.DESTRUCTIVE_TRANSPARENT}
      />
      {title && <h3 className="typo-text-16--bold text-full truncate">{title}</h3>}
      <OverlayNavArrows />
      <div className="ml-auto flex gap-16 items-center">
        <div className="flex items-center gap-x-8">{actions}</div>
        <Button
          icon="close"
          onClick={() => (onCloseOverlay ? onCloseOverlay() : onClose())}
          tone={ButtonToneProps.SECONDARY}
        />
      </div>
    </ContainerHead>
  );
};

export default OverlayHead;
